import React, { memo } from 'react';
import cls from './ConsumerBillingListHeader.module.scss';

const ConsumerBillingListHeader = memo(() => {
  return (
    <ul className={cls.Header}>
      <li className="regular-text">Transaction Date</li>
      <li className="regular-text">Type</li>
      <li className="regular-text">Amount</li>
    </ul>
  );
});

export default ConsumerBillingListHeader;
